import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAppStore } from './stores';

import LandingPage from './modules/LandingPage/LandingPage';
import Dashboard from './modules/Dashboard/Dashboard';
import OnBoardingProcess from './modules/OnBoardingProcess/Onboarding';
import ForgotPassword from 'components/ForgotPassword/ForgotPassword';
import { configureInterceptors } from './globalAxiosCall';

// Import SCSS
import './App.scss';

// Private Route component
interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const isAuthenticated = useAppStore((state) => state.authentication.isLoginSuccess);

  if (!isAuthenticated) {
    return <Navigate to="/landing" replace />;
  }

  return <>{children}</>;
};

const App: React.FC = () => {
  const isAuthenticated = useAppStore((state) => state.authentication.isLoginSuccess);
  const refreshToken = useAppStore((state) => state.user.refreshToken);

  // Configures the axios interceptor for the token configuration to simulate sessions
  if (refreshToken !== '') {
    configureInterceptors(refreshToken);
  }

  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/on-boarding" element={<OnBoardingProcess />} />
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/reset-password" element={<ForgotPassword />} />
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
